// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const LEGACY_DATA_IMPORT_INITIATION_STEP_SHAPES = [
  {
    stepType: PipelineStepType.LEGACY_DATA_IMPORT_INITIATION,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Initiation Results': {
        systemName: 'Initiation Results',
        displayName: 'Initiation Results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      category: {
        kind: 'string',
        required: true
      },
      refinedPrompt: {
        kind: 'string',
        required: true
      },
      qaCriteria: {
        kind: 'anything',
        required: true
      },
      qaThresholds: {
        kind: 'shape',
        required: true,
        fields: {
          correctnessThreshold: {
            kind: 'number',
            required: true
          },
          completenessThreshold: {
            kind: 'number',
            required: true
          }
        }
      },
      qaGuidelines: {
        kind: 'string',
        required: false
      },
      totalFiles: {
        kind: 'integer',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
